import React from 'react';

import { useCompanies, useUsers } from '@adsk/alloy-provider';
import Avatar from '@adsk/alloy-react-avatar';
import { Flex } from '@adsk/alloy-react-box';

import { Task } from '../../../types';

interface PlanTaskEntityBlockAssigneeSummaryProps {
  task: Task;
}

const PlanTaskEntityBlockAssigneeSummary = ({
  task,
}: PlanTaskEntityBlockAssigneeSummaryProps) => {
  const users = useUsers();
  const companies = useCompanies();

  const findCompany = () => {
    if (!task.company) {
      return null;
    }

    return companies.data.find(
      (company) => company.memberGroupId === task.company,
    );
  };

  const findAssignee = () => {
    if (!task.assignedTo) {
      return null;
    }

    return users.data.find((user) => user.autodeskId === task.assignedTo);
  };

  const company = findCompany();
  const assignee = findAssignee();
  const avatar = assignee?.imageUrl;

  if (!avatar && !company) {
    return null;
  }

  const calculateAssigneeSummary = () => {
    if (assignee?.name && !company) {
      return assignee?.name;
    }

    if (company && !assignee?.name) {
      return company.name;
    }

    return `${assignee?.name} (${company?.name})`;
  };

  return (
    <Flex alignItems="center" style={{ gap: '8px' }}>
      {!!avatar && (
        <Avatar
          image={assignee?.imageUrl}
          name={assignee?.name}
          size={Avatar.SIZES.SMALL_16}
        />
      )}
      <div>{calculateAssigneeSummary()}</div>
    </Flex>
  );
};

export default PlanTaskEntityBlockAssigneeSummary;
